import { shippingCompanyApi } from "./shippingCompany.api";

export const {
  useGetShippingCompaniesQuery,
  useListShippingCompaniesInfiniteQuery,
  useGetShippingCompanyQuery,
  useSearchShippingCompaniesQuery,
  useLazySearchShippingCompaniesQuery,
  useCreateShippingCompanyMutation,
  useEditShippingCompanyMutation,
  useDeleteShippingCompanyMutation,
  useBindShippingCompanyMutation
} = shippingCompanyApi;
